// removed by extract-text-webpack-plugin
module.exports = {"large":"only screen and (min-width: 993px)","medium":"only screen and (min-width: 768px)","container":"container-1srUq","bold":"bold-Sl5rs"};


//////////////////
// WEBPACK FOOTER
// ./src/components/premium/_lineItem.css
// module id = 1245
// module chunks = 1